import React, {useCallback, useEffect, useState} from 'react';
import {
  Alert,

  Text,
  TextInput,
  View,
  ScrollView,
  Pressable,
  StyleSheet,
  Linking,
  ActivityIndicator,
  Platform,
  ActionSheetIOS,
  Image,
} from 'react-native';
import {SafeAreaView} from 'react-native-safe-area-context';
import viewmapImg from '../../image/viewmap.png';

import { useNavigation, useRoute } from '@react-navigation/native';
import mystyles from '../../assets/styles/mystyles';
import {
  callApi,
  callPhone,
  formatDate,
  getLatLong,
  getTimeMs,
  getUserAddress,
  getUserIdEmailPhone,
  handleInterested,
  handleVerifyUser,
  performFollow,
  setCurrentZipCode,
} from '../Helper/Helper';
import AsyncStorage from '@react-native-async-storage/async-storage';

// Main list screen that shows consumer requests and adds the "I can help" button under each row.
const Eat = ({zipinput}) => {
  const navigation = useNavigation();
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [cUserId, setCUserId] = useState(null);
  const [cEmail, setCEmail] = useState(null);
  const [cPhone, setCPhone] = useState(null);
  const [zipcode, setZipcode] = useState(null);
  const [followBusy, setFollowBusy] = useState({}); // per-row loading state
  const [interestedItems, setInterestedItems] = useState({});
  const [isEditingZip, setIsEditingZip] = useState(false);
  const [zipDraft, setZipDraft] = useState('');

  const checkInterested = async (userId, itemId) => {
    try {
      const res = await callApi('GET', `/eabu-check-interest?cUserId=${userId}&itemId=${itemId}&providerType=EAT`);
      if (res === 1 || res?.status === 1 || res?.data === 1) {
        setInterestedItems(prev => ({ ...prev, [itemId]: true }));
      }
    } catch (e) {
      console.warn('Interest check failed', e);
    }
  };

  useEffect(() => {
    (async () => {
      try{
        const {userId,email,phone} = await getUserIdEmailPhone();
        setCUserId(userId);
        // Map to your state shape
        setCEmail(email ?? '');
        setCPhone(phone ?? '');

        const storedInterested = await AsyncStorage.getItem(`interested_map_${userId}`);
        if (storedInterested) {
          setInterestedItems(JSON.parse(storedInterested));
        }
      } catch (e) {
        console.warn('Failed to get user info', e);
      }
    })();
  }, []);



  const onInterestedPress = async (item) => {
    try {
      await handleInterested(item, "FOOD");
      Alert.alert('Thank you!', 'Please contact us for more information.');
    } catch (e) {
      console.error(e);
    }
  };

  const handleZipChangePress = () => {
    setZipDraft(zipcode ?? '');
    setIsEditingZip(true);
  };

  const handleZipSubmit = async () => {
    const nextZip = zipDraft.trim();
    if (!nextZip) {
      Alert.alert('Enter a ZIP code', 'Please enter a valid ZIP code.');
      return;
    }

    try {
      setLoading(true);
      await setCurrentZipCode(nextZip);
      setZipcode(nextZip);
      const json = await callApi('GET', '/eabu-eat/' + nextZip);
      setData(json);
      setError(null);
      setIsEditingZip(false);
    } catch (e) {
      setError(e);
    } finally {
      setLoading(false);
    }
  };


  useEffect(() => {
    const fetchData = async () => {
      let targetZip = zipinput;
      if(zipinput){
        try{
          setZipcode(zipinput);
          const json = await callApi('GET', '/eabu-eat/'+ zipinput);
          setData(json);
        } catch (e) {
          setError(e);
        } finally {
          setLoading(false);
        }
      }
      else{
        const storedZip = await AsyncStorage.getItem('session_zipcode');
        if (storedZip) {
          try {
            setZipcode(storedZip);
            const json = await callApi('GET', '/eabu-eat/'+ storedZip);
            setData(json);
            setLoading(false);
            return; // Exit if found in storage
          } catch (e) {
            console.log('Error fetching with stored zip:', e);
          }
        }
      }
    };
    fetchData().then(r => {});
  }, [zipinput]);


  if (loading) {
    return (
      <View style={{flex: 1, justifyContent: 'center', alignItems: 'center'}}>
        <ActivityIndicator size="large" color="#0000ff" />
      </View>
    );
  }
  if (error) return <Text>Error: {error.message}</Text>;

  const dataObject = JSON.parse(JSON.stringify(data));
  const items = dataObject?.Items ?? [];
  const count = dataObject?.Count ?? items.length ?? 0;
// Sort by createdAt/CreatedAt descending (newest first)
  const sortedItems = [...items].sort((a, b) => {
    const ta = getTimeMs(a?.CreatedAt ?? a?.createdAt);
    const tb = getTimeMs(b?.CreatedAt ?? b?.createdAt);
    return tb - ta;
  });


  if (count === 0) {
    return (
      <SafeAreaView>
        <View style={styles.emptyStateCard}>
          <Text style={styles.emptyStateTitle}>No food services yet</Text>
          <Text style={styles.emptyStateSubtitle}>
            near <Text style={styles.emptyStateZip}>{zipcode}</Text>
          </Text>
          <Pressable onPress={handleZipChangePress} accessibilityRole="button" hitSlop={6}>
            <Text style={styles.zipChangeLink}>Change ZIP</Text>
          </Pressable>
          <Text style={styles.emptyStateHint}>Try a nearby ZIP to see more options.</Text>
        </View>
        {isEditingZip && (
          <View style={styles.zipEditRow}>
            <TextInput
              style={styles.zipInput}
              placeholder="Enter ZIP code"
              value={zipDraft}
              onChangeText={setZipDraft}
              keyboardType="number-pad"
              maxLength={5}
            />
            <Pressable
              onPress={handleZipSubmit}
              style={({pressed}) => [styles.zipSubmitButton, pressed && styles.zipSubmitButtonPressed]}
              accessibilityRole="button"
            >
              <Text style={styles.zipSubmitText}>Update</Text>
            </Pressable>
            <Pressable
              onPress={() => setIsEditingZip(false)}
              style={({pressed}) => [styles.zipCancelButton, pressed && styles.zipCancelButtonPressed]}
              accessibilityRole="button"
            >
              <Text style={styles.zipCancelText}>Cancel</Text>
            </Pressable>
          </View>
        )}
      </SafeAreaView>
    );
  }


  return (
    <SafeAreaView>
      <ScrollView
        style={{ marginTop: 1 }}
        contentContainerStyle={{ alignContent: 'center', justifyContent: 'center' }}
        showsVerticalScrollIndicator={true}
      >
        {zipcode && (
          <View style={styles.zipHeader}>
            <Text style={styles.zipHeaderText}>
              Food services available around zip: {zipcode}
            </Text>
            <Pressable onPress={handleZipChangePress} accessibilityRole="button" hitSlop={6}>
              <Text style={styles.zipChangeLink}>Change</Text>
            </Pressable>
          </View>
        )}
        {isEditingZip && (
          <View style={styles.zipEditRow}>
            <TextInput
              style={styles.zipInput}
              placeholder="Enter ZIP code"
              value={zipDraft}
              onChangeText={setZipDraft}
              keyboardType="number-pad"
              maxLength={5}
            />
            <Pressable
              onPress={handleZipSubmit}
              style={({pressed}) => [styles.zipSubmitButton, pressed && styles.zipSubmitButtonPressed]}
              accessibilityRole="button"
            >
              <Text style={styles.zipSubmitText}>Update</Text>
            </Pressable>
            <Pressable
              onPress={() => setIsEditingZip(false)}
              style={({pressed}) => [styles.zipCancelButton, pressed && styles.zipCancelButtonPressed]}
              accessibilityRole="button"
            >
              <Text style={styles.zipCancelText}>Cancel</Text>
            </Pressable>
          </View>
        )}
        {sortedItems.map((item, idx) => {
          const rowKey = item?.ID ?? item?.itemId ?? item?.pk ?? String(idx);

          return (
            <View
              key={item?.ID ?? String(idx)}
              style={[mystyles.card, idx % 2 === 1 && mystyles.cardAlt]}
            >
              {!!item?.title && (
                <View style={styles.highlightedTitleContainer}>
                  <Text style={[mystyles.title, styles.highlightedTitle]}>{item.title}</Text>
                </View>
              )}

              <Text style={styles.offerDetailsLabel}>Offer Details:</Text>

              {!!item?.description && <Text style={mystyles.description}>{item.description}</Text>}

              <Text style={styles.postedText}>
                Posted: {formatDate(item?.CreatedAt ?? item?.createdAt)}
              </Text>

              {(!!item?.phone || !!item?.userId) && (
                <View style={styles.actionsRow}>
                  {!!item?.phone && (
                    <>
                      <Pressable
                        onPress={() => callPhone(item.phone)}
                        style={({pressed}) => [
                          styles.actionPill,
                          pressed && styles.actionPillPressed,
                        ]}
                        accessibilityRole="button"
                        accessibilityLabel="Call"
                        hitSlop={8}
                      >
                        <Text style={styles.actionIcon}>📞</Text>
                        <Text style={styles.actionText}>Call</Text>
                      </Pressable>

                      <Pressable
                        onPress={() => Linking.openURL(`sms:${item.phone}`)}
                        style={({pressed}) => [
                          styles.actionPill,
                          pressed && styles.actionPillPressed,
                        ]}
                        accessibilityRole="button"
                        accessibilityLabel="Text message"
                        hitSlop={8}
                      >
                        <Text style={styles.actionIcon}>💬</Text>
                        <Text style={styles.actionText}>Text</Text>
                      </Pressable>
                    </>
                  )}

                  {!!item?.userId && (
                    <Pressable
                      onPress={() =>
                        navigation.navigate('ProviderDetails', {
                          pUserId: item.userId,
                        })
                      }
                      style={({pressed}) => [
                        styles.actionPill,
                        pressed && styles.actionPillPressed,
                      ]}
                      accessibilityRole="button"
                      accessibilityLabel="View profile"
                      hitSlop={8}
                    >
                      <Text style={styles.actionIcon}>😊</Text>
                      <Text style={styles.actionText}>Profile</Text>
                    </Pressable>
                  )}

                  {!!item?.userId && (
                    <Pressable
                      onPress={() => handleVerifyUser(item.userId)}
                      style={({pressed}) => [
                        styles.actionPill,
                        pressed && styles.actionPillPressed,
                      ]}
                      accessibilityRole="button"
                      accessibilityLabel="View on map"
                      hitSlop={8}
                    >
                      <Image
                        source={viewmapImg}
                        style={styles.mapIcon}
                      />
                      <Text style={styles.actionText}>Map</Text>
                    </Pressable>
                  )}

                  {!!item?.userId && (
                    <View style={{ flexDirection: 'row', gap: 6, alignItems: 'center' }}>
                      <Pressable
                        accessibilityRole="button"
                        onPress={() => onInterestedPress(item)}
                        style={({pressed}) => [
                          styles.followPill,
                          pressed && styles.followPillPressed,
                        ]}
                        hitSlop={8}
                      >
                        <Text style={[styles.interestedText, {color: "#FFFFFF"}]}>I am interested</Text>
                      </Pressable>

                      <View style={[styles.actionPill, { backgroundColor: '#F1F5F9' }]}>

                        <Text style={[styles.interestedText]}>
                          {item?.interested_by ?? 0} people interested in this offer.
                        </Text>
                      </View>
                    </View>
                  )}
                </View>
              )}
            </View>
          );
        })}
      </ScrollView>
    </SafeAreaView>
  );
};

export default Eat;

const styles = StyleSheet.create({
  highlightedTitleContainer: {
    backgroundColor: '#F0F8FF',
    borderRadius: 8,
    padding: 12,
    marginBottom: 8,
    alignItems: 'center',
    shadowColor: '#000',
    shadowOffset: { width: 0, height: 2 },
    shadowOpacity: 0.1,
    shadowRadius: 4,
    elevation: 2,
  },
  highlightedTitle: {
    fontSize: 18,
    fontWeight: 'bold',
    color: '#007AFF',
    textAlign: 'center',
  },
  offerDetailsLabel: {
    fontSize: 16,
    fontWeight: 'bold',
    marginTop: 10,
    marginBottom: 5,
    color: '#333',
  },
  postedText: {
    fontSize: 12,
    color: '#666',
  },

  actionsRow: {
    marginTop: 12,
    flexDirection: 'row',
    flexWrap: 'wrap',
    alignItems: 'center',
    gap: 10,
  },
  actionPill: {
    flexDirection: 'row',
    alignItems: 'center',
    gap: 6,
    paddingVertical: 8,
    paddingHorizontal: 10,
    borderRadius: 999,
    backgroundColor: '#F8FAFC',
    borderWidth: 1,
    borderColor: '#E5E7EB',
  },
  actionPillPressed: {
    opacity: 0.75,
    transform: [{ scale: 0.99 }],
  },
  actionIcon: {
    fontSize: 12,
  },
  actionText: {
    fontSize: 10,
    fontWeight: '500',
    color: '#0F172A',
  },
  interestedText:{
    fontSize: 8,
    fontWeight: '400',
    color: '#0F172A',
  },
  mapIcon: {
    width: 25,
    height: 25,
    resizeMode: 'contain',
  },
  actionGroupRight: {
    flexDirection: 'row',
    alignItems: 'center',
    gap: 10,
  },

  followPill: {
    paddingVertical: 8,
    paddingHorizontal: 12,
    borderRadius: 999,
    backgroundColor: '#0A84FF',
    borderWidth: 1,
    borderColor: 'rgba(10,132,255,0.35)',
  },
  followPillPressed: {
    opacity: 0.85,
    transform: [{ scale: 0.99 }],
  },
  followPillDisabled: {
    opacity: 0.55,
  },
  followText: {
    fontSize: 12,
    fontWeight: '800',
    color: '#FFFFFF',
  },
  emptyStateCard: {
    marginHorizontal: 16,
    marginTop: 16,
    paddingVertical: 18,
    paddingHorizontal: 16,
    borderRadius: 12,
    backgroundColor: '#F8FAFC',
    borderWidth: 1,
    borderColor: '#E5E7EB',
    alignItems: 'center',
    shadowColor: '#000',
    shadowOffset: { width: 0, height: 2 },
    shadowOpacity: 0.08,
    shadowRadius: 6,
    elevation: 2,
  },
  emptyStateTitle: {
    fontSize: 16,
    fontWeight: '700',
    color: '#0F172A',
    textAlign: 'center',
  },
  emptyStateSubtitle: {
    marginTop: 4,
    fontSize: 13,
    fontWeight: '500',
    color: '#475569',
    textAlign: 'center',
  },
  emptyStateZip: {
    fontWeight: '700',
    color: '#0A84FF',
  },
  emptyStateHint: {
    marginTop: 8,
    fontSize: 11,
    color: '#64748B',
    textAlign: 'center',
  },
  zipHeader: {
    paddingVertical: 15,
    paddingHorizontal: 10,
    backgroundColor: '#f9f9f9',
    borderBottomWidth: 1,
    borderBottomColor: '#eee',
    marginBottom: 10,
  },
  zipHeaderText: {
    fontSize: 12,
    fontWeight: '500',
    color: '#333',
    textAlign: 'center',
  },
  zipChangeLink: {
    marginTop: 6,
    fontSize: 12,
    fontWeight: '600',
    color: '#0A84FF',
    textAlign: 'center',
    textDecorationLine: 'underline',
  },
  zipEditRow: {
    marginHorizontal: 12,
    marginBottom: 10,
    flexDirection: 'row',
    alignItems: 'center',
    gap: 8,
  },
  zipInput: {
    flex: 1,
    height: 44,
    borderWidth: 1,
    borderColor: '#D1D5DB',
    borderRadius: 8,
    paddingHorizontal: 10,
    backgroundColor: '#FFFFFF',
    fontSize: 12,
  },
  zipSubmitButton: {
    paddingHorizontal: 10,
    paddingVertical: 8,
    borderRadius: 8,
    backgroundColor: '#0A84FF',
  },
  zipSubmitButtonPressed: {
    opacity: 0.85,
  },
  zipSubmitText: {
    fontSize: 12,
    fontWeight: '600',
    color: '#FFFFFF',
  },
  zipCancelButton: {
    paddingHorizontal: 10,
    paddingVertical: 8,
    borderRadius: 8,
    backgroundColor: '#E5E7EB',
  },
  zipCancelButtonPressed: {
    opacity: 0.85,
  },
  zipCancelText: {
    fontSize: 12,
    fontWeight: '600',
    color: '#111827',
  },
});
